'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash.isequal');

var _lodash2 = _interopRequireDefault(_lodash);

var _shallowDiff = require('shallow-diff');

var _shallowDiff2 = _interopRequireDefault(_shallowDiff);

var _onlyClassificationsChanged = require('./only-classifications-changed');

var _onlyClassificationsChanged2 = _interopRequireDefault(_onlyClassificationsChanged);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (lastSearchQuery, searchQuery) {
  var diff = (0, _shallowDiff2.default)(lastSearchQuery, searchQuery);

  return !(0, _onlyClassificationsChanged2.default)(diff) && !(0, _lodash2.default)(lastSearchQuery, searchQuery);
};

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-refine-job-search/dist/lib/classification-counts-need-updating/classification-counts-need-updating.js
 ** module id = 468
 ** module chunks = 0
 **/